import { render, staticRenderFns } from "./PublicAuctionListItem.vue?vue&type=template&id=a39a56f2"
import script from "./PublicAuctionListItem.vue?vue&type=script&lang=js"
export * from "./PublicAuctionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports